import angular from 'angular';
import { parseConcessions } from '../helpers/parse-listing-concession';

module.exports = angular.module('common.models.listing', [
  require('../services/resource')
])
.factory('Listing', function(Addresses, odResource) {
  return odResource(Addresses.BASE_DWELLINGS_URL + '/search', null, {
    query: {
      method: 'POST',
      isArray: true,
      toast: { wait: 'Loading…' },
      transformResponse: function transformResponse(data) {
        if (!data) data = "[]"; // in tests the data doesn't come back
        let listings = angular.fromJson(data);
        return listings.map((listing) => {
          listing.price = listing.close_price || listing.list_price;
          listing.price_cents = listing.price * 100;
          listing.price_cents_per_sq_ft = listing.price_cents / listing.sq_ft;
          listing.coordinates = { lat: listing['lat'], lng: listing['lng'] };
          return addConcessionsFields(listing);
        });
      }
    }
  });

  function addConcessionsFields(listing) {
    // Adds {buyer, seller}_concession_{amont_cents, percentage} to listing if available
    return {
      ...listing,
      ...parseConcessions(listing, 'buyer'),
      ...parseConcessions(listing, 'seller')
    };
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/listing.js
 **/